"use strict";
/**
 * Hook for using intervals in other hooks
 */
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function useInterval(callback, delay) {
    var savedCallback = React.useRef(callback);
    React.useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    React.useEffect(function () {
        function tick() {
            savedCallback.current();
        }
        var id;
        if (delay !== null && delay !== undefined) {
            id = window.setInterval(tick, delay);
        }
        return function () { return clearInterval(id); };
    }, [delay]);
}
exports.default = useInterval;
//# sourceMappingURL=useInterval.js.map